import tier1Routes from '../data/tier1Routes.json'
import routeFacts from '../data/routeFacts.json'
import { slugify } from './slugify'

/**
 * Helpers over the build-time data in src/data (see scripts/seo/gen-route-data.mjs).
 *
 * Route pages used to build their "related routes" lists from
 * getPopularCitiesInState, which returns census place names in the same state.
 * On a Delhi route that meant links like "Delhi to NewDelhi Cab" and "Delhi to
 * BhalswaJahangirPur Cab" - 63 links per page pointing at intra-city non-routes
 * and pages with no CMS content. Everything here is restricted to Tier-1 routes,
 * which are exactly the pages that exist as prerendered HTML.
 */

const key = (from, to) => `${slugify(from)}|${slugify(to)}`

/** Real distance/duration/starting price for a pair, or null. */
export const getRouteFacts = (from, to) => routeFacts[key(from, to)] || null

/** Is this pair part of the Tier-1 set (i.e. does the page really exist)? */
export const isTier1Route = (from, to) =>
  (tier1Routes[slugify(from)] || []).includes(slugify(to))

/** Other Tier-1 destinations from the same origin. */
export const getSiblingRoutes = (from, excludeTo, limit = 12) =>
  (tier1Routes[slugify(from)] || [])
    .filter((d) => d !== slugify(excludeTo))
    .slice(0, limit)

/** Tier-1 origins that reach this destination. */
export const getInboundRoutes = (to, excludeFrom, limit = 12) => {
  const dest = slugify(to)
  const skip = slugify(excludeFrom)
  return Object.keys(tier1Routes)
    .filter((o) => o !== skip && tier1Routes[o].includes(dest))
    .slice(0, limit)
}

/** Top Tier-1 destinations from a city, for the city hub pages. */
export const getCityDestinations = (city, limit = 20) =>
  (tier1Routes[slugify(city)] || []).slice(0, limit)

export const titleCase = (slug) =>
  String(slug || '')
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
